(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ni-design-stories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('focusin', (event) => {
    const card = event.target.closest('.ni-design-stories__card');
    const list = card?.parentElement;
    if (!list || list.scrollWidth <= list.clientWidth) return;
    const cardBounds = card.getBoundingClientRect();
    const listBounds = list.getBoundingClientRect();
    if (cardBounds.left < listBounds.left || cardBounds.right > listBounds.right) {
      list.scrollBy({ left: cardBounds.left - listBounds.left - 4, behavior: 'instant' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ni-plinko-signup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ni-plinko-signup')) {
    class NativeInstinctDrop extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        if (!this.querySelector('[data-copy-text]')?.textContent.trim()) {
          this.readyObserver ??= new MutationObserver(() => this.connectedCallback());
          this.readyObserver.observe(this, { childList: true, subtree: true, characterData: true });
          return;
        }
        this.readyObserver?.disconnect();
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.text = JSON.parse(this.querySelector('[data-copy-text]').textContent);
        this.preview = this.dataset.preview === 'true';
        this.storageKey = this.preview ? 'ni-drop-preview-v1' : 'ni-drop-welcome-v1';
        this.state = 'ready';
        this.initialTitle = this.querySelector('[data-title]').textContent;
        this.initialIntro = this.querySelector('[data-intro]').textContent;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.querySelector('[data-step="play"]').setAttribute('aria-current', 'step');
        this.querySelector('[data-open]').addEventListener('click', () => this.open(), options);
        this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
        this.querySelector('[data-drop]').addEventListener('click', () => this.drop(), options);
        this.querySelector('[data-signup]').addEventListener('submit', event => this.submit(event), options);
        this.querySelector('[data-copy]')?.addEventListener('click', () => this.copy(), options);
        this.querySelector('[data-replay]')?.addEventListener('click', () => this.reset(), options);
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, options);
        this.dialog.addEventListener('close', () => this.closed(), options);
        this.closest('.shopify-section')?.addEventListener('shopify:section:select', () => this.open(), options);
        window.addEventListener('klaviyoForms', event => { if (event.detail?.type === 'open' && this.dialog.open) this.dialog.close(); }, options);
        if (!this.preview && this.stored().claimed) this.success();
        this.showTeaser();
        if (this.dataset.autoOpen === 'true' && this.dataset.home === 'true' && !window.Shopify?.designMode) {
          this.openTimer = setTimeout(() => {
            const active = document.activeElement;
            const editing = active && (active.matches('input, textarea, select') || active.isContentEditable);
            if (!this.isSuppressed() && !editing && !document.hidden && !document.querySelector('dialog[open], [role="dialog"][aria-modal="true"], cart-drawer[open], search-drawer[open]')) this.open();
          }, Number(this.dataset.delay || 20) * 1000);
        }
      }
      disconnectedCallback() {
        this.readyObserver?.disconnect();
        clearTimeout(this.openTimer);
        clearTimeout(this.revealTimer);
        cancelAnimationFrame(this.animationFrame);
        this.requestController?.abort();
        if (this.dialog?.open) this.dialog.close();
        if (this.locked && document.documentElement) document.documentElement.style.overflow = this.previousOverflow;
        this.controller?.abort();
        this.initialized = false;
      }
      stored() {
        try { return JSON.parse(localStorage.getItem(this.storageKey) || '{}'); } catch { return {}; }
      }
      remember(values) {
        try { localStorage.setItem(this.storageKey, JSON.stringify({ ...this.stored(), ...values })); } catch { }
      }
      isSuppressed() {
        const record = this.stored();
        return this.dataset.subscribed === 'true' || record.claimed || Date.now() - (record.dismissed || 0) < 5 * 86400000;
      }
      showTeaser() {
        this.querySelector('[data-open]').hidden = this.dialog.open;
        if (!this.preview && this.state === 'success') this.querySelector('[data-teaser-label]').textContent = this.text.claimedTeaser;
      }
      open() {
        if (this.dialog.open) return;
        clearTimeout(this.openTimer);
        this.returnFocus = document.activeElement;
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.locked = true;
        this.showTeaser();
        this.querySelector('[data-title]').focus({ preventScroll: true });
      }
      closed() {
        if (document.documentElement) document.documentElement.style.overflow = this.previousOverflow || '';
        this.locked = false;
        this.remember({ dismissed: Date.now() });
        this.showTeaser();
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
      }
      drop() {
        if (this.state !== 'ready') return;
        this.state = 'dropping';
        this.querySelector('[data-drop]').disabled = true;
        this.querySelector('[data-drop]').textContent = this.text.dropping;
        this.querySelector('[data-status]').textContent = this.text.dropping;
        const ball = this.querySelector('[data-ball]');
        const path = [[160,20],[160,50],[180,69],[176,75],[151,94],[160,99],[183,118],[176,123],[149,143],[160,147],[181,165],[176,171],[152,191],[160,195],[160,220],[160,212],[160,239]];
        const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 2800;
        let start;
        const animate = now => {
          start ??= now;
          const progress = duration ? Math.min((now - start) / duration, 1) : 1;
          const position = progress * (path.length - 1);
          const index = Math.min(Math.floor(position), path.length - 2);
          const fraction = position - index;
          const x = path[index][0] + (path[index + 1][0] - path[index][0]) * fraction;
          const y = path[index][1] + (path[index + 1][1] - path[index][1]) * fraction;
          ball.setAttribute('transform', `translate(${x} ${y})`);
          if (progress < 1) this.animationFrame = requestAnimationFrame(animate);
          else {
            this.state = 'landed';
            this.dialog.dataset.state = 'landed';
            this.querySelector('[data-status]').textContent = this.text.revealed;
            this.revealTimer = setTimeout(() => this.reveal(), duration ? 650 : 0);
          }
        };
        this.animationFrame = requestAnimationFrame(animate);
      }
      reveal() {
        this.state = 'claim';
        this.querySelector('[data-play-panel]').hidden = true;
        this.querySelector('[data-claim-panel]').hidden = false;
        this.querySelector('[data-step="play"]').removeAttribute('aria-current');
        this.querySelector('[data-step="claim"]').setAttribute('aria-current', 'step');
        this.querySelector('[data-title]').textContent = this.text.claimTitle;
        this.querySelector('[data-intro]').textContent = this.text.claimIntro;
        this.dialog.scrollTop = 0;
        if (this.dialog.open) this.querySelector('[data-title]').focus({ preventScroll: true });
      }
      async submit(event) {
        event.preventDefault();
        if (this.state !== 'claim' || !event.target.reportValidity()) return;
        if (this.querySelector('[data-honey]').value) return;
        const email = this.querySelector('[data-email]').value.trim();
        const submit = this.querySelector('[data-submit]');
        const originalText = submit.textContent;
        const error = this.querySelector('[data-error]');
        error.hidden = true;
        this.state = 'submitting';
        submit.disabled = true;
        submit.textContent = this.text.sending;
        let timeout;
        try {
          if (!this.preview) {
            this.requestController = new AbortController();
            timeout = setTimeout(() => this.requestController.abort(), 15000);
            const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.dataset.company)}`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-10-15' },
              signal: this.requestController.signal,
              body: JSON.stringify({ data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Native Instinct welcome drop',
                  profile: { data: { type: 'profile', attributes: {
                    email,
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                    properties: { 'Native Instinct Signup Source': 'Welcome drop', 'Native Instinct Offer Shown': this.dataset.reward }
                  } } }
                },
                relationships: { list: { data: { type: 'list', id: this.dataset.list } } }
              } })
            });
            if (response.status === 429) throw new Error('rate_limit');
            if (response.status !== 202) throw new Error('subscription_failed');
            this.remember({ claimed: true });
          }
          this.success();
        } catch (failure) {
          if (!this.isConnected) return;
          this.state = 'claim';
          error.textContent = failure.message === 'rate_limit' ? this.text.rateLimit : this.text.error;
          error.hidden = false;
        } finally {
          clearTimeout(timeout);
          submit.disabled = false;
          submit.textContent = originalText;
        }
      }
      success() {
        this.state = 'success';
        this.querySelector('[data-play-panel]').hidden = true;
        this.querySelector('[data-claim-panel]').hidden = true;
        this.querySelector('[data-success-panel]').hidden = false;
        this.querySelector('[data-dismiss]').hidden = true;
        this.querySelector('[data-title]').textContent = this.text.successTitle;
        this.querySelector('[data-intro]').hidden = true;
        this.querySelector('[data-email]').value = '';
        this.querySelector('[data-step="play"]').removeAttribute('aria-current');
        this.querySelector('[data-step="claim"]').setAttribute('aria-current', 'step');
        this.dialog.scrollTop = 0;
        if (this.dialog.open) this.querySelector('[data-title]').focus({ preventScroll: true });
        this.showTeaser();
      }
      async copy() {
        try {
          await navigator.clipboard.writeText(this.dataset.coupon);
          this.querySelector('[data-copy]').textContent = this.text.copied;
          this.querySelector('[data-status]').textContent = this.text.copied;
        } catch { this.querySelector('[data-status]').textContent = this.text.copyError; }
      }
      reset() {
        this.state = 'ready';
        delete this.dialog.dataset.state;
        this.querySelector('[data-success-panel]').hidden = true;
        this.querySelector('[data-play-panel]').hidden = false;
        this.querySelector('[data-dismiss]').hidden = false;
        this.querySelector('[data-title]').textContent = this.initialTitle;
        this.querySelector('[data-intro]').hidden = false;
        this.querySelector('[data-intro]').textContent = this.initialIntro;
        this.querySelector('[data-ball]').setAttribute('transform', 'translate(160 20)');
        this.querySelector('[data-drop]').disabled = false;
        this.querySelector('[data-drop]').textContent = this.querySelector('[data-replay]').textContent;
        this.querySelector('[data-step="claim"]').removeAttribute('aria-current');
        this.querySelector('[data-step="play"]').setAttribute('aria-current', 'step');
        this.querySelector('[data-status]').textContent = '';
        this.dialog.scrollTop = 0;
        this.querySelector('[data-drop]').focus({ preventScroll: true });
      }
    }
    customElements.define('ni-plinko-signup', NativeInstinctDrop);
  }

  } catch(e) { console.error(e); }
})();
})();
